import React, { useRef, useEffect, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import * as THREE from 'three';

const SimpleSphereModel = ({ rotationSpeed = 0.002, floatSpeed = 0.5, floatHeight = 0.1 }) => {
  const sphereRef = useRef();
  const textureRef = useRef();
  const [textureLoaded, setTextureLoaded] = useState(false);
  
  // Load the PNG texture
  useEffect(() => {
    const textureLoader = new THREE.TextureLoader();
    textureLoader.load('/Untitled-3.png', (texture) => {
      textureRef.current = texture;
      setTextureLoaded(true);
    });
  }, []);
  
  // Animation for gentle floating and rotation
  useFrame((state, delta) => {
    if (sphereRef.current) {
      // Gentle rotation
      sphereRef.current.rotation.y += rotationSpeed;
      
      // Subtle floating animation
      sphereRef.current.position.y = Math.sin(state.clock.elapsedTime * floatSpeed) * floatHeight;
    }
  });

  return (
    <>
      {/* Orbit controls for moving the sphere around */}
      <OrbitControls enableZoom={true} enablePan={true} />
      
      {/* Sphere with PNG texture */}
      {textureLoaded && (
        <mesh ref={sphereRef}>
          <sphereGeometry args={[1.5, 32, 32]} />
          <meshStandardMaterial 
            map={textureRef.current}
            metalness={0.4}
            roughness={0.6}
            emissive="#333333"
            emissiveIntensity={0.1}
          />
        </mesh>
      )}
      
      {/* Octahedron background element */}
      <mesh position={[0, 0, 0]} rotation={[0, 0, 0]}>
        <octahedronGeometry args={[2.1, 0]} />
        <meshBasicMaterial 
          color="#1A82FF" 
          wireframe={true} 
          transparent={true}
          opacity={0.1}
        />
      </mesh>
    </>
  );
};

export default SimpleSphereModel;